import React, { useEffect, useRef } from "react";
import "./Newsletter.css";

const Newsletter = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("reveal-visible");
            observer.disconnect();
          }
        });
      },
      { threshold: 0.2 },
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
  }, []);

  return (
    <section className="newsletter-section">
      <div className="newsletter-container">
        <div ref={sectionRef} className="newsletter-card reveal-item">
          <h2 className="newsletter-title">Subscribe to our newsletter</h2>

          <p className="newsletter-subtitle">
            Unlock your financial potential with Poonji Mitra. We provide
            personalized tools and insights to elevate your financial journey.
          </p>

          <form
            className="newsletter-form"
            onSubmit={(e) => e.preventDefault()}
          >
            <input
              type="email"
              placeholder="name@email.com"
              className="newsletter-input"
              required
            />

            <button type="submit" className="newsletter-submit-btn">
              Subscribe Now
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Newsletter;
